import React from "react";

export default function Loader() {
  return (
    <div className="flex items-center justify-center h-screen">
      <p className="text-gray-600">Laden...</p>
    </div>
  );
}
